<template>
  <div>
    <ul class="tags" style="list-style-type: none; margin: 0; padding: 0px">
      <template v-if="isDrag && !isDragging">
        <draggable
          v-model="vtags"
          class="dragarea"
          v-bind="{ handle: '.my-handle', filter: '.ignore-elements', animation: 150 }"
        >
          <tag-item
            v-for="(tag, index) in vtags"
            :key="'tag_' + vtags[index].text"
            class="item"
            :isDrag="isDrag"
            :options="options"
            v-model="vtags[index].text"
            @onDelete="removeTag(index)"
            @onChange="updateTag(index, $event)"
            @tags-changed="$emit('tags-changed', vtags)"
          ></tag-item>
          <li
            style="display: inline-block; margin-bottom: 3px;"
            slot="footer"
            v-if="max == 0 || max > vtags.length"
          >
            <span
              ref="addTagBtn"
              v-if="!isAdd"
              style="margin: 0px 0px; display: block"
              class="btn-tag"
              @click="onClickAddBtn"
            >
              <i class="fas fa-plus"></i>
              {{ btnText }}
            </span>
            <template v-else>
              <multiselect
                v-if="combobox"
                :options="options"
                v-model="newTag"
                :taggable="true"
                @tag="addTag"
                @input="addTag"
                :reset-after="true"
                :clearOnSelect="true"
                :hideSelected="true"
              >
              </multiselect>
              <input
                v-else
                ref="addInput"
                type="text"
                @blur="addNewTag"
                @keyup.enter="addNewTag"
                v-model="newTag"
                :placeholder="placeholder"
                @keyup="checkMaxLength"
              />
              <div
                v-if="
                  btnText === 'เพิ่มคำตัวเลือก' ||
                    btnText === 'Add choice' ||
                    btnText === 'ເພີ້ມຄ່າຕົວເລືອກ'
                "
              >
                <div class="text-xs-right">
                  <small>{{ newTag.length }}/20</small>
                </div>

                <small style="color:red" v-if="errorMaxlength">
                  {{ $t('message_cannot_be_longer_than_25_alphabets') }}</small
                >
              </div>
            </template>
          </li>
        </draggable>
      </template>
      <template v-else>
        <tag-item
          v-for="(tag, index) in vtags"
          :key="'tag_' + index"
          :isDrag="isDrag"
          :options="options"
          class="item"
          v-model="vtags[index].text"
          @onDelete="removeTag(index)"
          @onChange="updateTag(index, $event)"
          @tags-changed="$emit('tags-changed', vtags)"
        ></tag-item>

        <li
          style="display: inline-block; margin-bottom: 3px; margin-right: 3px"
          slot="footer"
          v-if="max == 0 || max > vtags.length"
        >
          <span
            ref="addTagBtn"
            v-if="!isAdd"
            style="margin: 0px 0px; display: block"
            class="btn-tag"
            @click="onClickAddBtn"
          >
            <i class="fas fa-plus"></i>
            {{ btnText }}
          </span>
          <input
            v-else
            ref="addInput"
            type="text"
            @blur="addNewTag"
            @keyup.enter="addNewTag"
            v-model="newTag"
            :placeholder="placeholder"
          />
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import draggable from 'vuedraggable'
import TagItem from './TagItem'
import SelectTag from '@/components/elements/SelectTag.vue'
export default {
  props: {
    value: undefined,
    tags: undefined,
    combobox: {
      default: false
    },
    edit: {
      type: Boolean,
      default: false
    },
    itemOption: {},
    placeholder: 'Type Message',
    btnText: {
      default: 'Add'
    },
    max: {
      type: Number,
      default: 0
    },
    isDrag: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Multiselect,
    draggable,
    TagItem,
    SelectTag
  },
  data: function() {
    return {
      errorMaxlength: false,
      isAdd: false,
      vtags: [],
      newTag: '',
      options: [],
      isDragging: false
    }
  },
  mounted: function() {
    this.options = this.itemOption || []
    if (this.tags) {
      this.vtags = this.tags.map(el => {
        return {
          ...el,
          id: Math.floor(Math.random() * 100) + 1
        }
      })
    }
  },
  methods: {
    addTag(newTag) {
      if (newTag.length <= 25) {
        this.newTag = newTag
        this.addNewTag()
        this.errorMaxlength = false
      } else {
        this.errorMaxlength = true
      }
    },
    onClickAddBtn: function() {
      var vm = this
      vm.isAdd = true
      vm.$nextTick(function() {
        if (vm.$refs.addInput) {
          vm.$refs.addInput.focus()
        }
      })
    },
    pressEnter: function(e) {
      if (e.keyCode === 13) {
        this.addNewTag()
      }
    },
    addNewTag: function() {
      var vm = this
      var tags = vm.newTag.split(',')
      if (vm.noSpaceAndSpecial(vm.newTag) === '') {
        vm.newTag = ''
        vm.isAdd = false
        vm.$emit('before-adding-tag', {
          type: 'add',
          tag: {
            // status: 'add',
            text: '',
            isDuplicate: false
          },
          addTag: function(event) {},
          error: function() {
            vm.isError = true
          }
        })
        return false
      }

      var isDuplicate = tags.find(function(tag, index) {
        var _tag = vm.noSpaceAndSpecial(tag)
        if (_tag != '') {
          if (vm.vtags.map(t => t.text).indexOf(_tag) !== -1) {
            return true
          } else {
            return false
          }
        } else return false
      })

      tags.forEach(tag => {
        vm.$emit('before-adding-tag', {
          type: 'add',
          tag: {
            // status: 'add',
            text: vm.noSpaceAndSpecial(tag),
            isDuplicate: isDuplicate,
            isOtherLanguage:
              vm.$store.getters.getPackage != 'premium' && vm.isCheckOtherLanguge(tag)
          },
          addTag: function(event) {
            vm.vtags.push({
              text: vm.noSpaceAndSpecial(tag),
              id: Math.floor(Math.random() * 100000) + 1
            })
            vm.$emit('tags-changed', vm.vtags)

            vm.newTag = ''
            vm.isAdd = false
            vm.$nextTick(function() {
              vm.$refs.addTagBtn.click()
            })
          },
          error: function() {
            vm.isError = true
          }
        })
      })
    },
    removeTag: function(index) {
      this.vtags.splice(index, 1)
      this.$emit('tags-changed', this.vtags)
    },
    updateTag: function(index, payload) {
      // console.log(payload)
      var vm = this
      var isDuplicate = false
      // console.log(vm.vtags.map(t => t.text).indexOf(payload.tag.text.trim()),index)
      if (
        vm.vtags.map(t => t.text).indexOf(payload.tag.text.trim()) !== index &&
        vm.vtags.map(t => t.text).indexOf(payload.tag.text.trim()) !== -1
      ) {
        isDuplicate = true
      } else {
        isDuplicate = false
      }
      payload.tag.isDuplicate = isDuplicate
      payload.type = 'edit'
      payload.index = index
      payload.tag.isOtherLanguage =
        vm.$store.getters.getPackage != 'premium' &&
        payload.tag.text.search(
          /[^ก-๛a-zA-Z0-9\~\$\&\+\,\:\;\=\?\@\#\|\'\"\<\>\.\^\*\(\)\%\!\-\/\[\]\\\_\{\}\s\u00a9\u00ae\u2000-\u3300\ud83c\ud000-\udfff\ud83d\ud000-\udfff\ud83e\ud000-\udfff]/gim
        ) !== -1
      vm.$emit('before-adding-tag', payload)
    },
    checkMaxLength() {
      if (
        this.newTag.indexOf(',') !== -1 &&
        (this.btnText === 'Add choice' ||
          this.btnText === 'เพิ่มคำตัวเลือก' ||
          this.btnText === 'ເພີ້ມຄ່າຕົວເລືອກ')
      ) {
        const values = this.newTag.split(',')
        let maxLengthExceeded = false
        values.forEach(value => {
          if (value.length > 20) {
            maxLengthExceeded = true
          }
        })
        if (maxLengthExceeded) {
          this.newTag = this.newTag.slice(0, -1)
        }
      }
    }
  },
  watch: {
    tags: function() {
      if (this.tags) {
        this.vtags = this.tags
      }
    },
    vtags: function() {
      this.$emit('tags-changed', this.vtags)
    }
  }
}
</script>

<style lang="scss" scoped>
// $primary-color: var(--primary-color);

// .tags {

//     .tag-item {
//         border: 1px solid $primary-color;
//         background: $primary-color; // margin-top: 2px;
//     }

//     .btn-tag {
//         border: 1px solid $primary-color;
//         color: $primary-color;
//     }
// }

// ul.tags {

//     li.tag {
//         border: 1px solid $primary-color;
//         color: $primary-color;
//         &.active {
//             background: $primary-color;
//         }
//     }
// }
</style>



// WEBPACK FOOTER //
// src/components/elements/Tags.vue